/* eslint-disable no-console */
type LimitType = {
  upperLimit?: number;
  lowerLimit?: number;
  errorMessage: string;
};

export type LimitRetValue = {
  limit?: number;
};

export const getLimit = (limits: LimitType) => {
  const { upperLimit, lowerLimit, errorMessage } = limits;

  let limit: LimitRetValue = { limit: 0 };
  switch (errorMessage) {
    case 'form-error-message-maximum-numeric-value':
    case 'form-lottery-name-error-message-max-length':
      limit = { limit: upperLimit };
      break;
    case 'form-error-message-minimum-numeric-value':
    case 'form-lottery-name-error-message-min-length':
      limit = { limit: lowerLimit ?? 0 };
      break;
    default:
      break;
  }
  return limit;
};
